module.exports = __webpack_public_path__ + "public/images/1-on-1-tutoring.756e51b84a26fed35f58e9928b8e9393.png";